var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Production-Foreman',{attrs:{"foreman-type":"aggregate","supplier":_vm.supplier,"specification":_vm.specification,"stockpile":_vm.stockpile}})
}
var staticRenderFns = []

export { render, staticRenderFns }